import { useNumericParams } from '@domain-group/react-hooks'

import useGeoStates from '@hooks/useGeoStates'
import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/module'

import GeoCountryEditRoutes from './routes'

const CampaignEdit = () => {
  const { geoCountryId } = useNumericParams()

  useGeoStates({ performHttpRequests: true })

  useReduxAction(
    'geoCountries',
    'loadGeoCountry',
    {
      entityId: geoCountryId,
    },
    [geoCountryId],
    {
      dispatchAction: action => action(geoCountryId),
      shouldPerformFn: ({ loading }: ModuleState) => !!geoCountryId && !loading,
    },
  )

  return (
    <GeoCountryEditRoutes />
  )
}

export default CampaignEdit
